import React from 'react';
import ClipLoader from 'react-spinners/ClipLoader';

export default function LoadingIndicator({loading}){

    return(
        <div style={{zIndex:99,position:'absolute',top:'50%',left:'50%'}}><ClipLoader size={180} loading={loading} color={'#43a047'}/></div>
    );
}